import _L, { _HttpMsgV2 } from "../../util/Labels";
import { _AgregarEventos, _EditarEvento, _EliminarEvento, _ObtenerConfiguracionInfo, _ObtenerEventosAgrupadosPorIdEvento, _ObtenerEventosPorIdsCalendarios, ICalendariosToSend } from "../../data/modulo/EventoCalendario";
import { _DICC_ESCUELA } from "../../data/modulo/Escuela";
import { _ModalConfirmacion } from "../controlD3/ModalThings/ModalConfirmacion";
import { _ModalConfirmacionBasicoV2 } from "../controlD3/ModalThings/ModalConfirmacionBasicoV2";
import { _ModalForm } from "../controlD3/ModalThings/ModalForm";
import { _ObtenerCalendarios } from "../../data/modulo/Calendario";
import { CalendarioGridV2 } from "../controlD3/CalendarioGrid/CalendarioGridV2";
import { CCalendarioGridV2Vista, ICGrupo } from "../controlD3/CalendarioGrid/CalendarioGridV2Base";
import { DataModuloMain } from "../../data/ModuloMain";
import { DateV2 } from "../../util/DateV2";
import { Entidad } from "../../data/Entidad";
import { FormGenerator } from "../controlD3/Formulario";
import { group as d3Group } from "d3-array";
import { HTMLProgressElement } from "../controlWC/ProgressComponent";
import { NotificacionV2 } from "../controlD3/NotificacionV2";
import { UIUtilPermission } from "../util/Permission";
import { UIUtilTime } from "../util/Time";
import { UIUtilViewCalendario } from "../utilView/Calendarios/Calendario";
import { VentanaBase } from "../controlD3/AVentanaBase";
import { IAgendaEvent } from "../panelCard/Grupo/GruposAgenda";
import { Router } from "../../routes/Router";
import * as d3 from "d3";
import ic_sync from '/image/iconos/ic_sync.svg?raw';

import CTipoEntidad = Entidad.CCalendarioTipoEntidad;

const ModuloCalendario = Entidad.CModulo.Calendarios
const PermisoAgregar = Entidad.CAccionPermiso.Agregar
const PermisoEditar = Entidad.CAccionPermiso.Editar
const PermisoEliminar = Entidad.CAccionPermiso.Eliminar
type IEventoCalendario = Entidad.IEventoPorCalendario;

export class UIVentanaCalendarios extends VentanaBase {
    private calendar: CalendarioGridV2;
    private ctrlProgress: HTMLProgressElement;
    private datos: {
        calendariosList: Entidad.ICalendario[];
        eventosList: Entidad.IEventoPorCalendario[];
    }

    constructor(content: d3.Selection<HTMLDivElement, undefined, HTMLElement, any>, modulo: Entidad.CModulo) {
        super(content, modulo);
        this.datos = {
            calendariosList: [],
            eventosList: [],
        }
        setTimeout(async () => {
            this.windowContent.classed("win_calendario", true);
            this.ctrlProgress = this.windowContent.append<HTMLProgressElement>("wc-progress").node();
            this.calendar = new CalendarioGridV2<IEventoCalendario>({ ID: "calendarios_1" })
                ._SetParent(this.windowContent)
                ._SetFocusDate(new Date())
                ._OnInputEvent((UIUtilPermission._HasAccionPermission(PermisoAgregar, ModuloCalendario)) ? (evento => {
                    this.OpenModal_AgregarEvento(<Partial<IEventoCalendario>>{
                        IdEscuela: 0,
                        IdCalendario: evento.IdCalendario,
                        Inicio: evento.Inicio?.toString(),
                        Fin: evento.Fin?.toISOString(),
                    });
                }) : null)
                ._DrawEventPreview(({ Descripcion, Inicio, Fin, IdCalendario }, container) => {
                    const cal = this.datos.calendariosList.find(d => IdCalendario == d.Id);
                    const escuela = _DICC_ESCUELA.get(cal?.IdEscuela);
                    const calColor = this.calendar._GetCalendarColor(IdCalendario);
                    const calColorGlass = this.calendar._GetCalendarColor(IdCalendario, .4);
                    const isFullDay = this.calendar._EventEvalFullDay(Inicio, Fin);

                    container.innerHTML = `
                    <div class="ev_tag">
                        <div class="cal_color" style="background-color:${calColor}"></div>
                        <b class="ev_name">${Descripcion || `(${_L("calendar.sintitulo")})`}</b>
                    </div>
                    <div class="cal_date">
                        <div>${UIUtilTime._DateFormatStandar(Inicio, "d MMM yyyy")}</div>
                        ${isFullDay
                            ? _L("calendar.fullday")
                            : `<div>
                                <span> ${UIUtilTime._DateFormatStandar(Inicio, "h12:mm")} </span> -
                                <span> ${UIUtilTime._DateFormatStandar(Fin, "h12:mm")} </span>
                            </div>`
                        }
                    </div>
                    <div class="cal_name" style="border-color:${calColor}; background-color:${calColorGlass};">
                        ${cal?.Nombre || ""}
                    </div>
                    <div>
                        ${escuela?.Nombre || ""}
                    </div>`
                })
                ._GetEventOptions((event) => ([
                    ...(() => {
                        if (event.Extra && !UIUtilPermission._HasAccionPermission(PermisoEditar, ModuloCalendario, event.Extra.IdEscuela))
                            return []
                        return [{ Label: _L("c_actions.editar"), Call: () => this.OpenModal_EditarEvento(event.Extra) }]
                    })(),
                    ...(() => {
                        if (event.Extra && !UIUtilPermission._HasAccionPermission(PermisoEliminar, ModuloCalendario, event.Extra.IdEscuela))
                            return []
                        return [{ Label: _L("c_actions.eliminar"), Call: () => this.OpenModal_EliminarEvento(event.Extra) }]
                    })(),
                ]))
                ._OnOnChangeTipoVista((tipoVista) => {
                    this.SyncEventos(true);
                })
                ._OnOnChangeFocusDate(() => {
                    this.SyncEventos(true);
                })
                ._OnChangeEvents(async (eventos) => {
                    // ******* WORKING *******
                    const eventEdit: Entidad.IEventoInGrid = eventos[0].Extra as any; // (Es decir el evento que será editado, mantiene sus propiedades hasta que se realiza la edición)
                    const eventGrid: Entidad.IEventoInGrid = eventos[0] as any; // (Contiene las propiedades del evento que se modifican en el control)
                    const hasConfig = eventEdit.IdAgrupador != 0;
                    /* if (hasConfig) {
                        this.ProgressVisible(true);
                        const res = await _ObtenerConfiguracionInfo(eventEdit.Id, eventEdit.IdAgrupador);
                        this.ProgressVisible(false);
                        if (res.Resultado < 1) {
                            this.refreshEvents(this.datos.eventosList);
                            this.calendar.RefreshView();
                            this.notificacion._Mostrar("Ocurrió un error", "ADVERTENCIA");
                            return;
                        }
                        const infoEvent = res.Datos;
                    } */
                    let typeEdit: Entidad.CTipoAccionEvento = Entidad.CTipoAccionEvento.Unico;
                    if (hasConfig) {
                        const optsEdit: IDatoBase[] = [];
                        let optCurrentEvent = true;
                        let optThisAndNext = true;
                        let optAll = true;

                        const changeOnlyDate = UIUtilTime._GetValidatorDateYMDV2(eventEdit.Inicio) != UIUtilTime._GetValidatorDateYMDV2(new Date(eventGrid.Inicio));

                        // » Al evento se le cambia la fecha (Ej. 5 feb -> 6 feb)
                        if (changeOnlyDate)
                            optAll = false;

                        if (optCurrentEvent) optsEdit.push({ Id: Entidad.CTipoAccionEvento.Unico, Name: _L("calendario.tag_current_event") })
                        // if (optThisAndNext) optsEdit.push({ Id: Entidad.CTipoAccionEvento.Futuros, Name: _L("calendario.tag_current&future_event") })
                        if (optAll) optsEdit.push({ Id: Entidad.CTipoAccionEvento.Todos, Name: _L("calendario.tag_all_event") })

                        typeEdit = Entidad.CTipoAccionEvento.Todos;
                        if (optsEdit.length) {
                            const formEditionConfirm = new FormGenerator();
                            formEditionConfirm._Crear({
                                LabelMaxWidth: 130,
                                schema: [
                                    {
                                        model: "EditaConfig",
                                        type: "radioList",
                                        radioListAttr: {
                                            ValueMember: "Id",
                                            DisplayMember: "Name",
                                            Data: optsEdit,
                                            Direction: "vertical",
                                            ReturnOnlyValueMember: true,
                                            required: true,
                                        }
                                    }
                                ]
                            }, { EditaConfig: optsEdit[0].Id })
                            const confrim = await _ModalConfirmacionBasicoV2({
                                Title: _L("c_actions.editar"),
                                Width: 300,
                                Content: formEditionConfirm._Form.node()
                            })
                            typeEdit = formEditionConfirm._Data.EditaConfig
                            if (!confrim || !typeEdit) {
                                this.refreshEvents(this.datos.eventosList);
                                this.calendar.RefreshView();
                                if (!typeEdit) this.notificacion._Mostrar(_L("calendario.notif_err_noedittype"), "ADVERTENCIA")
                                return;
                            }
                        }
                    }

                    const calendar = this.datos.calendariosList.find(d => d.Id == eventEdit.IdCalendario);
                    let calendarioInfo: ICalendariosToSend = {
                        IdCalendario: calendar.Id,
                        IdKinder: calendar.IdEscuela,
                        IdEscolaridad: calendar.IdEscolaridad,
                        IdGrupo: calendar.TipoEntidad == Entidad.CCalendarioTipoEntidad.Grupo ? calendar.IdEntidad : 0,
                        TipoEvento: calendar.TipoEntidad == Entidad.CCalendarioTipoEntidad.Alimento ? -1 : calendar.TipoEntidad,
                        IdEntidad: calendar.IdEntidad,
                    }

                    this.ProgressVisible(true);
                    const res = await _EditarEvento(
                        {
                            IdEvento: eventEdit.Id,
                            TipoEdicion: typeEdit as any,
                            Nombre: eventEdit.Nombre,
                            IsAllDay: null,
                            Inicio: new DateV2(eventGrid.Inicio)._ToISOLocalString(),
                            Fin: new DateV2(eventGrid.Fin)._ToISOLocalString(),
                            IdCalendario: eventEdit.IdCalendario as any,
                            TipoRecurrencia: null,
                            VarianteRecurrencia: null,
                            TipoFinRecurrencia: null,
                            FinRecurrencia: null,
                            NRecurrencias: 0,
                            IdKinder: calendarioInfo.IdKinder,
                            IdEscolaridad: calendarioInfo.IdEscolaridad,
                            IdGrupo: calendarioInfo.IdGrupo,
                            TipoEvento: calendarioInfo.TipoEvento,
                            ReuseConfig: true,
                            IdEntidad: calendarioInfo.IdEntidad,
                        }
                    )
                    this.ProgressVisible(false);
                    if (res.Resultado > 0) {
                        this.SyncEventos();
                    } else {
                        this.refreshEvents(this.datos.eventosList);
                        this.calendar.RefreshView();
                        let errMsg = _HttpMsgV2({ Resultado: res.Resultado, EndPointName: res.EndPointName })
                        this.notificacion._Mostrar(errMsg, "ADVERTENCIA");
                    }
                    return res;
                })
                ._EventEnableInteraction((evento) => {
                    if (!evento.Extra) return true
                    return UIUtilPermission._HasAccionPermission(PermisoEditar, ModuloCalendario, evento.Extra.IdEscuela)
                })
            // ._OnChangeCalendars((cals) => {
            //     this.SyncEventos();
            // })

            this.calendar._ControlContainer._areaNavegacion.append("div")
                .classed("btn_sync", true)
                .html(ic_sync)
                .call(cont => {
                    const btnSync = cont.select("svg");
                    btnSync.on("click", () => {
                        btnSync.classed("anim_syncing", true);
                        this.SyncCalendarios().finally(() => {
                            btnSync.classed("anim_syncing", false);
                        });
                    })
                })
            await this.SyncCalendarios();

            const dataEvent: IAgendaEvent = history.state;
            if (!dataEvent) return;

            Router._ReplaceState("escuelas/calendarios", "", null);
            const mode = dataEvent["mode"];

            if (mode == Entidad.CAccionPermiso.Agregar) {
                const cal = this.datos.calendariosList.find(d => d.IdEntidad == dataEvent.IdOrigin)
                this.OpenModal_AgregarEvento(<Partial<IEventoCalendario>>{
                    IdCalendario: cal?.Id || 0,
                });
                return;
            }

            this.calendar._SetFocusDate(new Date(dataEvent.StrStart))
            this.calendar._SelectTipoVista("DAY");
            await this.SyncCalendarios();

            const calendarEvent = this.datos.eventosList.find(ev => ev.Id == dataEvent.Id);
            if (!calendarEvent) {
                this.notificacion._Mostrar(_L("calendario.notif_notavailable_event"), "ADVERTENCIA");
                return;
            }

            calendarEvent.Inicio = new DateV2(new Date(calendarEvent.Inicio))._SetTimeZoneByIdSchool(calendarEvent.IdEscuela) as any;
            calendarEvent.Fin = new DateV2(new Date(calendarEvent.Fin))._SetTimeZoneByIdSchool(calendarEvent.IdEscuela) as any;
            switch (mode) {
                case Entidad.CAccionPermiso.Editar:
                    this.OpenModal_EditarEvento(calendarEvent);
                    break;
                case Entidad.CAccionPermiso.Eliminar:
                    this.OpenModal_EliminarEvento(calendarEvent);
                    break;
            }
        });
    }

    private async SyncCalendarios(syncEvents = true, showProgressBar = true): Promise<void> {
        // const escuelas = DataModuloMain._GetReqDataArrayByName("Escuela")
        const idsEscuelas = DataModuloMain._GetReqDataArrayByName("Escuela")
            .filter(d => UIUtilPermission._HasModulePermission(ModuloCalendario, d.IdKinder))
            .map(d => d.IdKinder)

        if (!idsEscuelas.length) {
            this.calendar._SetGrupos([])._SetCalendarios([]);
            this.SyncEventos();
            return;
        }
        if (showProgressBar) this.ProgressVisible(true);
        return _ObtenerCalendarios(idsEscuelas).then(async (res) => {
            let resCalendarios = (res.Datos || []);
            resCalendarios = resCalendarios.sort((a, b) => d3.ascending(a.Nombre.toLowerCase(), b.Nombre.toLowerCase()))
            this.datos.calendariosList = resCalendarios;
            const agrupadores = DataModuloMain._GetReqDataArrayByName("Escuela")
                .filter(k => resCalendarios.some(c => k.IdKinder == c.IdEscuela))
            const idsNewCalsInControl = (() => {
                const existCals = this.calendar._CalendarsList;
                return resCalendarios
                    .filter(r => !existCals.some(c => c.Id == r.Id))
                    .map(d => d.Id);
            })()

            const GruposCal: ICGrupo[] = []
            GruposCal.push(...agrupadores.map(d => ({
                Id: d.IdKinder + "",
                Descripcion: d.Nombre,
                Tipos: [
                    { Id: CTipoEntidad.Escuela + "", Descripcion: _L("general.general") },
                    { Id: CTipoEntidad.Grupo + "", Descripcion: _L("c_calendario_tipoentidad.grupo") },
                    { Id: CTipoEntidad.Alimento + "", Descripcion: _L("c_calendario_tipoentidad.alimento") },
                ],
                Calendarios: resCalendarios.filter(c => d.IdKinder == c.IdEscuela).map(cal => cal.Id)
            })))

            d3Group(resCalendarios, (cal) => cal.IdEscuela).forEach((calendars, idEscuela) => {
                d3Group(calendars, (calendar) => calendar.TipoEntidad).forEach((cals, tipoEntidad) => {
                    GruposCal.push({ Id: idEscuela + "_" + tipoEntidad, Descripcion: "", Calendarios: cals.map(d => d.Id) })
                })
            })

            this.calendar
                ._SetGrupos(GruposCal)
                ._SetCalendarios(resCalendarios.map(d => ({
                    Id: d.Id,
                    Descripcion: d.Nombre,
                    IdGrupo: d.IdEscuela + "",
                    IdTipo: d.TipoEntidad,
                })))
                ._CheckCalendars(idsNewCalsInControl, true)

            if (showProgressBar) this.ProgressVisible(false);
            if (syncEvents)
                await this.SyncEventos()
        })
    }

    private async SyncEventos(showProgressBar = true): Promise<void> {
        const tipoVista = this.calendar._TipoVista;
        const focusDate = this.calendar._CurrentDateFocused;
        const ids = this.datos.calendariosList.map(d => d.Id)

        const [dtInicio, dtFin] = (() => {
            const [anio, mes, dia] = [focusDate.getFullYear(), focusDate.getMonth(), focusDate.getDate()];
            const inicio = new Date(anio, mes, dia, -1, 0, 0, 0);
            const fin = new Date(anio, mes, dia, 24, 0, 0, 0);
            if (tipoVista == CCalendarioGridV2Vista.WEEK) {
                inicio.setDate(inicio.getDate() - 7);
                fin.setDate(fin.getDate() + 7);
            }
            if (tipoVista == CCalendarioGridV2Vista.MONTH) {
                inicio.setDate(0);
                fin.setDate(32);
            }
            if (tipoVista == CCalendarioGridV2Vista.YEAR) {
                inicio.setMonth(0);
                inicio.setDate(0);
                fin.setMonth(11);
                fin.setDate(32);
            }
            return [inicio, fin];
        })()

        if (!ids.length) {
            this.refreshEvents([])
            return;
        }
        if (showProgressBar) this.ProgressVisible(true);
        return _ObtenerEventosPorIdsCalendarios(ids, dtInicio, dtFin).then((res) => {
            const evetos = (res.Datos || []);
            const EventosInCalendar: Entidad.IEventoPorCalendario[] = []
            evetos.forEach(d => {
                // d.Inicio = new DateV2(d.Inicio)._SetTimeZoneByIdSchool(d.IdEscuela)._ToISOString();
                // d.Fin = new DateV2(d.Fin)._SetTimeZoneByIdSchool(d.IdEscuela)._ToISOString();
                const daysBlock = UIUtilTime._GetTimeElapsedSimple(new Date(d.Inicio), new Date(d.Fin)).Days()

                let auxDateB1 = new Date(d.Inicio);
                if (daysBlock > 1) {
                    while (auxDateB1.getTime() < new Date(d.Fin).getTime()) {
                        const init = new Date(auxDateB1);
                        auxDateB1.setDate(auxDateB1.getDate() + 1);
                        EventosInCalendar.push({ ...d, Inicio: init.toISOString(), Fin: auxDateB1.toISOString(), BlockReference: d })
                    }
                } else {
                    EventosInCalendar.push({ ...d })
                }
            })

            this.datos.eventosList = EventosInCalendar;

            this.refreshEvents(EventosInCalendar)
            if (showProgressBar) this.ProgressVisible(false);
        })
    }

    private refreshEvents(eventosInCalendar: Entidad.IEventoPorCalendario[]) {
        let decrementAuxId = 0;
        this.calendar._SetEventos(eventosInCalendar.map(d => ({
            Id: d.BlockReference ? decrementAuxId-- : d.Id,
            Descripcion: d.Nombre,
            Inicio: new DateV2(new Date(d.Inicio))._SetTimeZoneByIdSchool(d.IdEscuela),
            Fin: new DateV2(new Date(d.Fin))._SetTimeZoneByIdSchool(d.IdEscuela),
            IdCalendario: d.IdCalendario,
            Extra: {
                ...d,
                Inicio: new DateV2(new Date(d.Inicio))._SetTimeZoneByIdSchool(d.IdEscuela),
                Fin: new DateV2(new Date(d.Fin))._SetTimeZoneByIdSchool(d.IdEscuela)
            },
        })));
    }

    private ProgressVisible(show = true) {
        const progress = this.ctrlProgress;
        if (this["__timerShowProgress__"]) {
            clearTimeout(this["__timerShowProgress__"])
        }
        this["__timerShowProgress__"] = setTimeout(() => {
            this["__timerShowProgress__"] = null;
            progress._Visible = show;
        }, 10);
    }

    private OpenModal_AgregarEvento(event: Partial<IEventoCalendario>) {
        _ModalForm({
            Title: _L("c_actions.agregar"),
            GetForm: (_, mt) => {
                let form = UIUtilViewCalendario._GetEventFormBuilded(PermisoAgregar, null, this.datos.calendariosList, this.calendar);
                UIUtilViewCalendario._AssignDataToForm(form, this.calendar, event);
                return form;
            },
            OnAccept: async (form, mt) => {
                const formData = form._Data;
                let calendars = formData.IdCalendarios.flatMap<Entidad.ICalendario>(id => this.datos.calendariosList.find(d => d.Id == id) ?? []);
                let res = await UIUtilViewCalendario._OnAcceptEventAdd(formData, calendars);

                if (res.Resultado > 0) this.SyncEventos();
                return res;
            }
        })
    }

    private async OpenModal_EditarEvento(event: IEventoCalendario) {
        let eventInfo: Entidad.IEventoInfo;
        _ModalForm({
            Title: _L("calendario.edit_event"),
            GetForm: () => {
                return (
                    UIUtilViewCalendario._GetEventFormBuilded(
                        PermisoEditar, event, this.datos.calendariosList, this.calendar
                    )
                )
            },
            DrawContent: async (_, form, mt) => {
                if (!event.IdAgrupador) { UIUtilViewCalendario._AssignDataToForm(form, this.calendar, event); return }

                mt.Progress.attr("oculto", false);
                mt.BtnRight._Enable(false);
                eventInfo = await UIUtilViewCalendario._GetEventInfoFromSv(event);
                mt.Progress.attr("oculto", true);
                mt.BtnRight._Enable(true);
                if (!eventInfo) {
                    this.notificacion._Mostrar(_L("general.notif_fail"), "ADVERTENCIA");
                    mt.Modal._Ocultar();
                    return;
                }
                UIUtilViewCalendario._AssignDataToForm(form, this.calendar, event, eventInfo);
            },
            OnAccept: async (form) => {
                const calendar = this.datos.calendariosList.find(d => d.Id == form._Data.IdCalendarios as any);
                let res = await UIUtilViewCalendario._OnAcceptEventEdition(form, event, calendar, eventInfo)
                if (!res) return;
                if (res.Resultado > 0) this.SyncEventos()
                return res;
            }
        })
    }

    private async OpenModal_EliminarEvento(event: IEventoCalendario) {
        let form = new FormGenerator();

        _ModalConfirmacion({
            Title: _L("c_actions.eliminar"),
            Width: 300,
            Message: _L("calendario.confirma_eliminar", event.Nombre),
            DrawContent: async (cont, mt) => {
                mt.Progress.attr("oculto", false);
                mt.Modal._DeshabilitarBtns();
                let groupedEvents: Entidad.IEventoPorCalendario[];
                const res = await _ObtenerEventosAgrupadosPorIdEvento(event.Id);
                if (res.Resultado > 0) {
                    groupedEvents = res.Datos;
                } else {
                    NotificacionV2._Mostrar(_L("calendario.notif_err_geteventgroup"), "ADVERTENCIA")
                    mt.Modal._Ocultar();
                    return;
                }
                mt.Modal._HabilitarBtns();
                mt.Progress.attr("oculto", true);

                form = UIUtilViewCalendario._GetDeleteEventForm(event, cont, groupedEvents)
                cont.append(() => form._Form.node());
            },
            OnAccept: async (mt) => {
                const tipoDelete = form._Data.EliminaConfig;
                mt.Progress.attr("oculto", false);
                const res = await _EliminarEvento(event.Id, tipoDelete);
                if (res.Resultado > 0) {
                    NotificacionV2._Mostrar(_L("calendario.notif_success_event_delete"), "INFO")
                    this.SyncEventos();
                } else {
                    NotificacionV2._Mostrar(_L("calendario.notif_err_event_delete"), "ADVERTENCIA")
                }
                mt.Progress.attr("oculto", true);
            }
        })
    }
}